import { apiClientGeral } from '@/plugins/axios'

export default {
  getRamais() {
    return apiClientGeral().get('/ramais')
  },
  getRamal(id) {
    return apiClientGeral().get(`/ramais/${id}`)
  },
  postRamal(ramal) {
    return apiClientGeral().post('/ramais', ramal)
  },
  postRamaisMultiplos(ramais) {
    return apiClientGeral().post('/ramaismany', ramais)
  },
  putRamal(ramal) {
    return apiClientGeral().put(`/ramais/${ramal._id}`, ramal)
  },
  deleteRamal(id) {
    return apiClientGeral().delete(`/ramais/${id}`)
  },

  getTroncos() {
    return apiClientGeral().get('/troncos')
  },
  getrotas() {
    return apiClientGeral().get('/rotas')
  },
  getGrupos() {
    return apiClientGeral().get('/gruposcaptura')
  },
  getGruposDeRotas() {
    return apiClientGeral().get('/grupo-rotas')
  }
}
